<template>
    <div class="bui-box">
        <p class="input-title" v-html="title"></p>
        <slot></slot>
        <input type="text" :class="{'error': errMsg != ''}" :placeholder="placeholder" :value="value" @input="$emit('input', $event.target.value)" @blur="$emit('blur')" />
    </div>
</template>

<script>
    export default {
        name: "inputBox",
        props: {
            "placeholder": {
                type: String,
                required: false
            },
            "title": {
                type: String,
                required: true
            },
            "errMsg": {
                type: String,
                required: false
            },
            "value": {
                type: String,
                required: false
            },
        }
    };
</script>

<style lang="scss" scoped>
    .bui-box {
        width: 1170px;
        p {
            margin: 0;
            display: inline-block;
            font-size: 16px;
            color: #444444;
            letter-spacing: 0;
        }
        input {
            margin-top: 20px;
            width: 100%;
            height: 50px;
            font-size: 14px;
            color: #444444;
            background: #FFFFFF;
            border: 2px solid #CCCCCC;
            border-radius: 100px;
            text-indent: 20px;
            box-sizing: border-box;
            // user-select: none;
            outline: none;
            &:hover, &:focus {
                border-color: #50BBE5;
            }
            &.error {
                border-color: #FF5555;
            }
        }
        input::-webkit-input-placeholder {
            color: #CCCCCC;
        }
        input::-moz-placeholder {
            color: #CCCCCC;
        }
        input::-moz-placeholder {
            color: #CCCCCC;
        }
        input:-ms-input-placeholder {
            color: #CCCCCC;
        }
    }
</style>